<template>
  <div
    v-if="!showSkeleton"
    ref="propertyListing"
    data-file="PropertyListingBackup2024"
    class="max-w-100 position-relative property w-100"
    :class="[
      listing,
      classList,
      {
        shortlist: shortlistedLocal,
        'updated-property-tile': enableUpdatedPropertyTile,
        'updated-property-tile-surface': enableUpdatedPropertyTile,
        'updated-property-tile-surface--reduced-shadow':
          enableUpdatedPropertyTile && reducedShadow,
        'updated-property-tile-featured':
          enableUpdatedPropertyTile && property.isFeatured,
        'updated-property-tile-admin': enableUpdatedPropertyTile && admin,
        'updated-property-tile-admin-wrapper':
          enableUpdatedPropertyTile && admin,
        'tw-rounded-2xl tw-border tw-border-gray-200 tw-shadow-lg focus-within:tw-shadow-md hover:tw-shadow-md':
          !enableUpdatedPropertyTile,
      },
      !property.bookable ? 'tw-opacity-50' : '',
    ]"
  >
    <div class="position-absolute t-minus-160px"></div>

    <div
      v-if="!isShortlistView && !property.bookable"
      class="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-gap-[4px] tw-rounded-[14px_0_16px_0] tw-bg-error-shade tw-px-[16px] tw-py-[8px] tw-text-[12px] tw-font-[800] tw-text-white"
    >
      Property Let
    </div>

    <a
      class="property-card-link noSelect focus-visible:tw-rounded-[18px] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
      :class="enableUpdatedPropertyTile ? 'tw-flex tw-h-full tw-flex-col' : ''"
      :href="property.path"
      data-cy="property-listing"
      data-uh="property-card"
      data-testid="property-listing"
      @click.self.prevent="redirectToPropertyPage"
    >
      <div
        class="property_img"
        :class="
          enableUpdatedPropertyTile
            ? property.isFeatured
              ? 'tw-shrink-0'
              : 'tw-shrink-0 tw-rounded-tl-[24px] tw-rounded-tr-[24px]'
            : 'tw-rounded-tl-2xl tw-rounded-tr-2xl'
        "
      >
        <div
          v-if="
            (isShortlistView || (enableShortlistInSearch && shortlistActive)) &&
            (!enableShortlistInSearch || shortlistSelectionMode)
          "
          class="tw-absolute tw-z-[5] tw-flex tw-items-center tw-justify-center"
          :class="
            shortlistSelectionMode
              ? 'tw-right-3 tw-top-3 tw-h-[32px] tw-w-[32px]'
              : 'tw-left-0 tw-top-0 tw-h-[56px] tw-w-[56px] tw-rounded-br-[8px] tw-bg-white'
          "
          data-shortlist-selection-control
          @click.stop
        >
          <label
            class="tw-relative tw-flex tw-cursor-pointer tw-items-center tw-p-2"
          >
            <input
              type="checkbox"
              class="tw-peer tw-sr-only"
              :checked="localIsSelected"
              aria-label="Select property"
              @change="onSelectChange"
            />

            <span
              class="tw-aspect-square tw-box-content tw-flex tw-h-[32px] tw-w-[32px] tw-items-center tw-justify-center tw-rounded-[50px] tw-border-2 tw-border-[#E5E7EB] tw-bg-white/60 tw-transition-all tw-duration-150 peer-focus-visible:tw-ring-2 peer-focus-visible:tw-ring-[#61B3E5] peer-focus-visible:tw-ring-offset-2"
              :class="
                shortlistSelectionMode
                  ? 'peer-checked:tw-border peer-checked:tw-border-[#E5E7EB] peer-checked:tw-bg-white'
                  : 'tw-rounded-[4px] tw-border-[#3B4143] tw-bg-white peer-checked:tw-border-[#00A2E1] peer-checked:tw-bg-[#00A2E1]'
              "
            >
              <svg
                v-if="shortlistSelectionMode && localIsSelected"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                class="tw-aspect-square tw-h-[24px] tw-w-[24px] tw-shrink-0"
              >
                <path
                  data-figma-bg-blur-radius="4"
                  d="M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21508 0.913451 7.4078C0.00519941 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.807 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0865C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6934 24 14.3734 24 12C23.9966 8.81843 22.7313 5.76814 20.4816 3.51843C18.2319 1.26872 15.1816 0.00335979 12 0ZM17.2685 9.88384L10.8069 16.3454C10.7212 16.4312 10.6194 16.4993 10.5073 16.5457C10.3953 16.5922 10.2752 16.6161 10.1538 16.6161C10.0325 16.6161 9.91243 16.5922 9.80037 16.5457C9.68831 16.4993 9.5865 16.4312 9.50077 16.3454L6.73154 13.5762C6.55834 13.4029 6.46103 13.168 6.46103 12.9231C6.46103 12.6781 6.55834 12.4432 6.73154 12.27C6.90475 12.0968 7.13967 11.9995 7.38462 11.9995C7.62957 11.9995 7.86449 12.0968 8.0377 12.27L10.1538 14.3873L15.9623 8.57769C16.0481 8.49193 16.1499 8.4239 16.2619 8.37748C16.374 8.33107 16.4941 8.30718 16.6154 8.30718C16.7367 8.30718 16.8568 8.33107 16.9688 8.37748C17.0809 8.4239 17.1827 8.49193 17.2685 8.57769C17.3542 8.66345 17.4223 8.76527 17.4687 8.87733C17.5151 8.98938 17.539 9.10948 17.539 9.23077C17.539 9.35205 17.5151 9.47216 17.4687 9.58421C17.4223 9.69627 17.3542 9.79808 17.2685 9.88384Z"
                  fill="var(--UH-Secondary-500, #00A2E1)"
                />
              </svg>
              <svg
                v-else-if="!shortlistSelectionMode"
                xmlns="http://www.w3.org/2000/svg"
                class="tw-h-[14px] tw-w-[14px] tw-text-white"
                width="13"
                height="9"
                viewBox="0 0 13 9"
                fill="none"
              >
                <path
                  d="M12.0859 0.355469C12.4414 0.683594 12.4414 1.25781 12.0859 1.58594L5.08594 8.58594C4.75781 8.94141 4.18359 8.94141 3.85547 8.58594L0.355469 5.08594C0 4.75781 0 4.18359 0.355469 3.85547C0.683594 3.5 1.25781 3.5 1.58594 3.85547L4.48438 6.72656L10.8555 0.355469C11.1836 0 11.7578 0 12.0859 0.355469Z"
                  :fill="
                    localIsSelected && shortlistSelectionMode
                      ? '#00A2E1'
                      : 'white'
                  "
                ></path>
              </svg>
            </span>
          </label>
        </div>

        <div
          v-if="swiperSlides.length > 1"
          class="min-h-165px property-listing-swiper swiper-container tw-group"
          :class="[imgClasses, swiperClasses]"
        >
          <!-- Right Arrow -->
          <div
            data-tile-click-ignore
            class="tw-absolute tw-right-[16px] tw-z-10 tw--translate-y-1/2 tw-transform tw-opacity-0 tw-transition-opacity tw-duration-200 hover:tw-opacity-100 group-hover:tw-opacity-50 group-hover:hover:tw-opacity-100"
            :class="
              enableUpdatedPropertyTile
                ? 'tw-top-[60%] tw--mr-[7px] tw-flex tw-h-[48px] tw-w-[48px] tw-items-center tw-justify-center'
                : 'tw-top-1/2'
            "
            @click="handleSwiperNavClick('next', $event)"
          >
            <CaretCircle v-if="enableUpdatedPropertyTile" direction="right" />
            <img
              v-else
              :src="cdnAsset('svg/caret-circle-right.svg')"
              class="tw-h-[40px] tw-w-[40px]"
              alt="Next"
            />
          </div>

          <!-- Left Arrow -->
          <div
            data-tile-click-ignore
            class="tw-absolute tw-left-[16px] tw-z-10 tw--translate-y-1/2 tw-transform tw-opacity-0 tw-transition-opacity tw-duration-200 hover:tw-opacity-100 group-hover:tw-opacity-50 group-hover:hover:tw-opacity-100"
            :class="
              enableUpdatedPropertyTile
                ? 'tw-top-[60%] tw--ml-[7px] tw-flex tw-h-[48px] tw-w-[48px] tw-items-center tw-justify-center'
                : 'tw-top-1/2 tw-rotate-180'
            "
            @click="handleSwiperNavClick('prev', $event)"
          >
            <CaretCircle v-if="enableUpdatedPropertyTile" direction="left" />
            <img
              v-else
              :src="cdnAsset('svg/caret-circle-right.svg')"
              class="tw-h-[40px] tw-w-[40px]"
              alt="Previous"
            />
          </div>

          <!-- Slider main container -->
          <div :id="swiperId" ref="swiper" class="propertyListingSwiper swiper">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper">
              <!-- Slides -->
              <div
                v-for="(image, index) in swiperSlides"
                :key="`slide-${index}`"
                class="property-image-grey-background swiper-slide"
                :class="imageFrameClass"
              >
                <picture>
                  <source
                    media="(max-width: 430px)"
                    :srcset="
                      getResponsiveImageUrls(image)?.mobile ||
                      cdnAsset('svg/no-image.svg')
                    "
                  />
                  <source
                    media="(max-width: 576px)"
                    :srcset="
                      getResponsiveImageUrls(image)?.small ||
                      cdnAsset('svg/no-image.svg')
                    "
                  />
                  <source
                    media="(max-width: 768px)"
                    :srcset="
                      getResponsiveImageUrls(image)?.mobile ||
                      cdnAsset('svg/no-image.svg')
                    "
                  />
                  <source
                    media="(max-width: 1024px)"
                    :srcset="
                      getResponsiveImageUrls(image)?.tablet ||
                      cdnAsset('svg/no-image.svg')
                    "
                  />
                  <source
                    media="(max-width: 1199px)"
                    :srcset="
                      getResponsiveImageUrls(image)?.twoCol ||
                      cdnAsset('svg/no-image.svg')
                    "
                  />
                  <source
                    media="(min-width: 1200px)"
                    :srcset="
                      getResponsiveImageUrls(image)?.desktop ||
                      cdnAsset('svg/no-image.svg')
                    "
                  />
                  <img
                    :alt="property.shortDescription"
                    :src="
                      getResponsiveImageUrls(image)?.fallback ||
                      cdnAsset('svg/no-image.svg')
                    "
                    decoding="async"
                    :loading="
                      index === 0 && iteration <= eagerImageCount
                        ? 'eager'
                        : 'lazy'
                    "
                    :fetchpriority="
                      index === 0 && iteration <= eagerImageCount
                        ? 'high'
                        : 'auto'
                    "
                    class="tw-block tw-h-full tw-w-full tw-object-cover tw-object-center tw-transition-transform tw-duration-100"
                  />
                </picture>
              </div>
            </div>
            <!-- If we need pagination -->
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div v-else-if="property.mainImage" :class="imageFrameClass">
          <picture>
            <source
              media="(max-width: 430px)"
              :srcset="
                getResponsiveImageUrls(propertyMainImage)?.mobile ||
                cdnAsset('svg/no-image.svg')
              "
            />
            <source
              media="(max-width: 576px)"
              :srcset="
                getResponsiveImageUrls(propertyMainImage)?.small ||
                cdnAsset('svg/no-image.svg')
              "
            />
            <source
              media="(max-width: 768px)"
              :srcset="
                getResponsiveImageUrls(propertyMainImage)?.mobile ||
                cdnAsset('svg/no-image.svg')
              "
            />
            <source
              media="(max-width: 1024px)"
              :srcset="
                getResponsiveImageUrls(propertyMainImage)?.tablet ||
                cdnAsset('svg/no-image.svg')
              "
            />
            <source
              media="(max-width: 1199px)"
              :srcset="
                getResponsiveImageUrls(propertyMainImage)?.twoCol ||
                cdnAsset('svg/no-image.svg')
              "
            />
            <source
              media="(min-width: 1200px)"
              :srcset="
                getResponsiveImageUrls(propertyMainImage)?.desktop ||
                cdnAsset('svg/no-image.svg')
              "
            />
            <img
              :src="
                getResponsiveImageUrls(propertyMainImage)?.fallback ||
                property.mainImage
              "
              :loading="iteration <= eagerImageCount ? 'eager' : 'lazy'"
              decoding="async"
              :class="imgClasses"
              class="tw-h-full tw-w-full tw-object-cover"
              :alt="property.shortDescription"
            />
          </picture>
        </div>
        <div
          class="tw-absolute tw-z-[19] tw-flex"
          :class="
            enableUpdatedPropertyTile &&
            property.isFeatured &&
            !lastEnquiredAtRelative &&
            !showIncentiveBadge
              ? 'tw-left-0 tw-top-0'
              : 'tw-left-[16px] tw-top-[16px]'
          "
        >
          <div
            v-if="lastEnquiredAtRelative"
            class="tw-flex tw-items-center tw-rounded-full tw-bg-[#1B7E41] tw-px-2 tw-py-1 tw-text-xs tw-font-semibold tw-text-white"
          >
            {{
              housemateGroupActive && isLastEnquiredOlderThanThreeWeeks
                ? 'Enquired'
                : `Enquired - ${lastEnquiredAtRelative}`
            }}
          </div>
          <div
            v-else-if="showIncentiveBadge && !enableUpdatedPropertyTile"
            class="tw-rounded-[16px] tw-leading-[23px]"
            data-uh="property-incentive"
          >
            <ListingIncentive2024
              :type="property.incentive.type"
              :svg-icon-path="cdnAsset('svg/info-white-icon.svg')"
              :message="property.incentive.message"
            />
          </div>
          <div
            v-else-if="!showIncentiveBadge && property.isFeatured"
            class="tw-flex tw-items-center tw-text-white"
            :class="
              enableUpdatedPropertyTile
                ? 'tw-justify-center tw-gap-[4.541px] tw-rounded-[0_0_18.162px_0] tw-bg-button-grad tw-px-[18.162px] tw-py-[9.081px] tw-font-sans tw-text-[16px] tw-font-[800] tw-not-italic tw-leading-[150%] tw-backdrop-blur-[2.270270347595215px]'
                : 'tw-space-x-1 tw-rounded-[16px] tw-bg-secondary-orange tw-pb-[4px] tw-pl-[4px] tw-pr-[8px] tw-pt-[4px] tw-text-[12px] tw-font-bold tw-leading-[18px]'
            "
          >
            <img
              v-if="enableUpdatedPropertyTile"
              :src="cdnAsset('svg/featured-star-24.svg')"
              alt=""
              aria-hidden="true"
              class="tw-h-[24px] tw-w-[24px]"
            />
            <img
              v-else
              v-lazy="cdnAsset('svg/star-icon.svg')"
              alt="Star Icon"
              class="tw-h-[16px] tw-w-[16px]"
              :src="cdnAsset('svg/no-image.svg')"
            />
            <span> Featured </span>
          </div>
        </div>
        <!-- Only one badge ever paints in this corner. When the rule for a
             just-dropped listing is settled, JustDroppedPill becomes the first
             branch here, ahead of all three below. -->
        <!-- <div-->
        <!-- v-if="enableUpdatedPropertyTile"-->
        <!-- class="tw-absolute tw-left-[16px] tw-top-[19px] tw-z-[19] tw-flex"-->
        <!--        >-->
        <!-- <JustDroppedPill />-->
        <!-- </div>-->
        <!-- The design puts the incentive and the type pill at 19/14 and
             19/16, their own inset, so they sit apart from the badges above that
             share the 16/16 corner. Only one of the two ever renders. -->
        <div
          v-if="enableUpdatedPropertyTile && showIncentiveBadge"
          class="tw-absolute tw-left-[14px] tw-right-[58px] tw-top-[19px] tw-z-[19] tw-flex"
        >
          <div
            class="tw-rounded-[16px] tw-px-0.5 tw-leading-[16px]"
            data-uh="property-incentive"
          >
            <ListingIncentive2024
              :type="property.incentive.type"
              :svg-icon-path="cdnAsset('svg/info-white-icon.svg')"
              :message="property.incentive.message"
              enable-updated-property-tile
            />
          </div>
        </div>
        <div
          v-if="showPropertyTypePill"
          class="tw-absolute tw-left-[16px] tw-top-[19px] tw-z-[19] tw-flex"
        >
          <PropertyTypePill
            :advert-type="property.advertType"
            :property-type="property.type"
            :spare-rooms-available-count="property.spareRoomsAvailableCount"
            :variant-kind="property.variantKind"
            :rooms-available-count="property.roomsAvailableCount"
          />
        </div>
        <!-- The heart sits at 18px; the pills take 19px so they centre on it. -->
        <div
          v-if="
            enableUpdatedPropertyTile &&
            !useFullWidthHousemateVoteButtons &&
            !shortlistReadOnly &&
            !shortlistSelectionMode
          "
          class="tw-absolute tw-right-[16px] tw-top-[18px] tw-z-[19] tw-flex tw-gap-[16px]"
        >
          <button
            v-if="property.bookable && property.isFeatured && !isShortlistView"
            type="button"
            class="with-content-after-none tw-aspect-square tw-relative tw-flex tw-h-[32px] tw-w-[32px] tw-items-center tw-justify-center tw-rounded-[50px] tw-border tw-border-gray-200 tw-bg-[rgba(150,150,150,0.40)] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
            aria-label="Share this property"
            data-tile-click-ignore
            @click.stop.prevent="shareProperty"
          >
            <img
              :src="cdnAsset('svg/share-network-white-24.svg')"
              alt=""
              aria-hidden="true"
              class="tw-h-[24px] tw-w-[24px]"
            />
          </button>
          <span
            v-if="shareStatus"
            class="tw-absolute tw-right-0 tw-top-[40px] tw-whitespace-nowrap tw-rounded tw-bg-[#3B4143] tw-px-2 tw-py-1 tw-text-xs tw-text-white"
            role="status"
            aria-live="polite"
          >
            {{ shareStatus }}
          </span>
          <button
            v-if="isShortlistView && !shortlistSelectionMode"
            type="button"
            class="text-body with-content-after-none tw-relative tw-flex tw-h-[40px] tw-w-[40px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-bg-white tw-text-[#3B4143] before:tw-absolute before:tw--inset-[4px] before:tw-content-[''] hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-text-uhblue-700 focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
            role="button"
            aria-label="Remove from shortlist"
            @click.prevent="$emit('remove-from-shortlist', property.id)"
          >
            <Trash stroke-color="currentColor" />
          </button>

          <span
            v-else-if="property.bookable && !shortlistSelectionMode"
            class="with-content-after-none tw-relative tw-box-content tw-flex tw-aspect-[1/1] tw-h-[32px] tw-w-[32px] tw-items-center tw-justify-center tw-rounded-[50px] tw-border tw-border-gray-200 tw-bg-[rgba(150,150,150,0.40)] before:tw-absolute before:tw--inset-[7px] before:tw-content-['']"
            role="button"
            :aria-label="
              shortlistedLocal ? 'Remove from shortlist' : 'Add to shortlist'
            "
            :data-shortlisted="shortlistedLocal ? '1' : '0'"
            :data-uh="shortlistedLocal ? 'shortlist-remove' : 'shortlist-add'"
            :data-add-shortlist="property.id"
            @click.prevent="toggleShortlist($event)"
          >
            <HeartOutline :filled="isShortlisted" />
          </span>
        </div>
        <Loading
          v-if="reloading"
          label=""
          wrapper-classes="bg-white-50 h-100 l-50 position-absolute transform-translate-minus-50 t-50 w-100 z-i-1"
        ></Loading>
      </div>

      <div
        class="tw-relative tw-p-[16px]"
        :class="
          enableUpdatedPropertyTile ? 'tw-flex tw-flex-1 tw-flex-col' : ''
        "
      >
        <div
          v-if="!enableUpdatedPropertyTile"
          class="tw-mb-[16px] tw-flex tw-flex-row tw-flex-wrap tw-items-start tw-gap-[8px] xs:tw-items-center"
        >
          <div
            class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[2px]"
          >
            <div class="tw-w-[25px] md:tw-w-auto">
              <img
                v-lazy="cdnAsset('svg/seal-check-icon.svg')"
                alt="Seal Check Icon"
                class="tw-h-[24px] tw-w-[24px]"
                :src="cdnAsset('svg/no-image.svg')"
              />
            </div>
            <span>Bills Included</span>
          </div>
          <div
            v-if="isBTRProperty"
            class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[6px]"
          >
            <div class="tw-w-[25px] md:tw-w-auto">
              <img
                v-lazy="cdnAsset('svg/uh-halls-icon.svg')"
                alt="Halls Icon"
                class="tw-h-[24px] tw-w-[24px]"
                :src="cdnAsset('svg/no-image.svg')"
              />
            </div>
            <span v-if="isBTRProperty">Private Halls</span>
            <span v-else>Halls</span>
          </div>
          <div
            v-else-if="isSpareRoomProperty"
            class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[6px]"
          >
            <div class="tw-w-[25px] md:tw-w-auto">
              <img
                v-lazy="cdnAsset('svg/phosphor/door-open.svg')"
                alt="Spare Room Icon"
                class="tw-h-[20px] tw-w-[20px]"
                :src="cdnAsset('svg/no-image.svg')"
              />
            </div>
            <span>Spare rooms</span>
          </div>
          <div
            v-else-if="!isBTRProperty"
            class="tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-rounded-[16px] tw-border tw-border-uhblue-150 tw-px-[8px] tw-py-0 tw-text-[14px] tw-font-normal tw-leading-[27px] tw-text-uhblue-450 md:tw-pl-[8px]"
          >
            <div class="tw-w-[25px] md:tw-w-auto">
              <img
                v-lazy="cdnAsset('svg/bathtub-icon.svg')"
                alt="Bathtub Icon"
                class="tw-h-6 tw-w-6"
                :src="cdnAsset('svg/no-image.svg')"
              />
            </div>
            <span dusk="property-bathroom-count">
              {{ property.bathroomCount }}
              <span :class="{ 'tw-hidden': mapIsOpen }">bathrooms</span>
            </span>
          </div>

          <template
            v-if="useFullWidthHousemateVoteButtons || shortlistReadOnly"
          ></template>

          <button
            v-else-if="isShortlistView && !shortlistSelectionMode"
            type="button"
            class="text-body with-content-after-none tw-absolute tw-right-[16px] tw-top-[-28px] tw-z-10 tw-flex tw-h-[50px] tw-w-[50px] tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-gray-300 tw-bg-white tw-text-[#3B4143] hover:tw-border-uhblue-700 hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-text-uhblue-700 focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
            role="button"
            aria-label="Remove from shortlist"
            @click.prevent="$emit('remove-from-shortlist', property.id)"
          >
            <Trash stroke-color="currentColor" />
          </button>

          <div
            v-else-if="property.bookable && !shortlistSelectionMode"
            class="align-items-center h-50px justify-content-center r-15px rounded-circle shortlist_expanded w-50px z-i-1 tw-absolute tw-right-[16px] tw-top-[-28px] tw-flex"
          >
            <span
              class="heart_new align-items-center border-none d-flex overflow-visible rounded-0 text-body with-content-after-none"
              role="button"
              :aria-label="
                shortlistedLocal ? 'Remove from shortlist' : 'Add to shortlist'
              "
              :data-shortlisted="shortlistedLocal ? '1' : '0'"
              :data-uh="shortlistedLocal ? 'shortlist-remove' : 'shortlist-add'"
              :data-add-shortlist="property.id"
              @click.prevent="toggleShortlist($event)"
            >
              <i
                class="tw-before-h-24px tw-before-w-24px"
                :class="{ activated: isShortlisted }"
              />
            </span>
          </div>
        </div>

        <div class="property_rooms_address position-relative tw-mb-[16px]">
          <h2
            class="tw-mb-0 tw-truncate tw-font-semibold tw-leading-[27px] tw-text-primary-grey"
            :class="
              enableUpdatedPropertyTile ? 'tw-text-[18px]' : 'tw-text-[20px]'
            "
            dusk="property-bedroom-count"
            data-testid="search-results-property-tile-header"
          >
            {{ property.propertyName }}
          </h2>
          <div
            class="tw--ml-[4px] tw-mb-0 tw-flex tw-items-center tw-space-x-1 tw-overflow-hidden tw-text-[14px] tw-font-normal tw-leading-[21px] tw-text-darkergrey"
          >
            <img
              :src="cdnAsset('svg/map-pin-grey.svg')"
              alt="Map Pin Icon"
              class="tw-h-[16px] tw-max-h-[16px] tw-w-[17px] tw-max-w-[17px] tw-shrink-0 md:tw-h-[21px] md:tw-max-h-[21px] md:tw-w-[21px] md:tw-max-w-[21px]"
            />
            <span class="tw-truncate">{{ property.addressShort }}</span>
          </div>
        </div>

        <div
          v-if="enableUpdatedPropertyTile"
          class="tw-mb-[16px] tw-flex tw-flex-col tw-gap-[16px]"
        >
          <div
            v-if="spareRoomsAvailableLabel || occupiedRoomsLabel"
            class="tw-flex tw-flex-wrap tw-gap-[8px] xs2:tw-gap-[3px] lg:tw-gap-[6px]"
          >
            <PropertyTileChip v-if="spareRoomsAvailableLabel" theme="orange">
              <template #icon>
                <BedRoom />
              </template>
              {{ spareRoomsAvailableLabel }}
            </PropertyTileChip>

            <PropertyTileChip v-if="occupiedRoomsLabel" theme="grey">
              <template #icon>
                <Occupied />
              </template>
              {{ occupiedRoomsLabel }}
            </PropertyTileChip>
          </div>

          <div
            class="tw-flex tw-flex-wrap tw-gap-[8px] xs2:tw-gap-[4px] md:tw-gap-[8px]"
          >
            <PropertyTileChip>
              <template #icon>
                <SealCheck />
              </template>
              Bills included
            </PropertyTileChip>

            <PropertyTileChip v-if="isBTRProperty && btrRoomOptionsLabel">
              {{ btrRoomOptionsLabel }}
            </PropertyTileChip>

            <PropertyTileChip v-else-if="!isBTRProperty">
              <template #icon>
                <Bathtub />
              </template>
              <span dusk="property-bathroom-count">
                {{ property.bathroomCount }}
                <span :class="{ 'tw-hidden': mapIsOpen }">
                  {{ bathroomLabel }}
                </span>
              </span>
            </PropertyTileChip>
          </div>
        </div>

        <div
          class="property_details"
          :class="enableUpdatedPropertyTile ? 'tw-mt-auto' : ''"
        >
          <div
            v-if="enableUpdatedPropertyTile"
            class="tw-flex tw-flex-nowrap tw-items-center tw-justify-between tw-gap-[4px]"
          >
            <h3
              class="tw-font-inter tw-mb-0 tw-flex tw-h-[24px] tw-shrink-0 tw-items-baseline tw-gap-[4px] tw-whitespace-nowrap tw-text-[16px] tw-font-medium tw-leading-[24px] tw-text-darkergrey"
            >
              <span
                v-if="showPriceFromPrefix"
                class="updated-property-tile-full-label tw-text-[14px]"
                >From</span
              >
              <span
                dusk="property-price"
                class="tw-text-[18px] tw-font-bold tw-text-[#00628F]"
              >
                <span class="updated-property-tile-compact-label">
                  {{ compactDisplayPrice }}
                </span>
                <span class="updated-property-tile-full-label">
                  {{ displayPrice }}
                </span>
              </span>
              <span class="tw-text-[12px]">{{ pricePeriodLabel }}</span>
            </h3>

            <div
              class="tw-flex tw-items-center tw-gap-[4px] tw-overflow-hidden tw-text-[12px] tw-font-normal tw-leading-[21px] tw-text-primary-grey"
            >
              <Calendar class="tw-shrink-0" />
              <span class="tw-truncate" :title="property.availableFromShort">
                <span class="updated-property-tile-compact-label">
                  {{ compactAvailableFrom }}
                </span>
                <span class="updated-property-tile-full-label">
                  {{ property.availableFromShort }}
                </span>
              </span>
            </div>
          </div>
          <h3
            v-else-if="isBTRProperty || isSpareRoomProperty"
            class="tw-font-inter tw-flex tw-items-baseline tw-gap-1 tw-text-[16px] tw-text-base tw-font-medium tw-leading-[24px] tw-text-darkergrey"
            :class="liveAt || housemateGroupActive ? 'tw-mb-[13px]' : 'tw-mb-0'"
          >
            <span class="tw-flex tw-flex-wrap tw-space-x-1 sm:tw-pb-1">
              <!-- Price -->
              <span
                dusk="property-price"
                class="tw-font-bold tw-text-uhblue-450"
              >
                £{{ property.cheapestRoomPrice }}
              </span>

              <!-- Paid per -->
              <span class="tw-tw-leading-[24px] tw-text-[14px]">per week</span>
            </span>
            <!-- BTR Room Count (optional A/B test pill) -->
            <span
              v-if="isBTRProperty && property.btrRoomsCount"
              class="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-1 tw-rounded-[100px] tw-border tw-border-uhblue-150 tw-p-[8px] tw-text-[14px] tw-leading-[17px] tw-text-uhblue-450"
            >
              <span class="tw tw-font-bold">{{ property.btrRoomsCount }}</span>
              room
              {{ property.btrRoomsCount > 1 ? 'options' : 'option' }}
            </span>
            <span
              v-else-if="
                isSpareRoomProperty && property.spareRoomsAvailableCount
              "
              class="tw-ml-auto tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-1 tw-rounded-[100px] tw-border tw-border-uhblue-150 tw-p-[8px] tw-text-[14px] tw-leading-[17px] tw-text-uhblue-450"
            >
              <span class="tw tw-font-bold">
                {{ property.spareRoomsAvailableCount }}
              </span>
              {{ property.spareRoomsAvailableCount > 1 ? 'rooms' : 'room' }}
              available
            </span>
          </h3>
          <h3
            v-else
            class="tw-font-inter tw-mb-[13px] tw-flex tw-min-h-[35px] tw-items-center tw-text-[16px] tw-text-base tw-font-medium tw-leading-[24px] tw-text-darkergrey"
          >
            <!-- Price -->
            <span>
              <span
                v-if="property.showFrom"
                class="tw-tw-leading-[24px] tw-text-[14px]"
                >From
              </span>
              <span
                dusk="property-price"
                class="tw-font-bold tw-text-uhblue-450"
                >{{ price }}&nbsp;</span
              >
            </span>

            <!-- Paid per -->
            <span class="tw-tw-leading-[24px] tw-text-[14px]">
              per person per week</span
            >
          </h3>
          <div
            v-if="!enableUpdatedPropertyTile"
            class="tw-flex tw-items-center"
          >
            <div
              class="tw-flex tw-items-center tw-space-x-1 tw-text-[10px] tw-font-semibold tw-leading-[18px] tw-text-uhblue-450"
            >
              <img
                v-lazy="cdnAsset('svg/info-blue.svg')"
                alt="Info Icon"
                class="tw-h-[16px] tw-w-[16px]"
                :src="cdnAsset('svg/no-image.svg')"
              />
              <span v-if="liveAt"
                >{{ liveAt }}, {{ availableFromLowercase }}</span
              >
              <span v-else>{{ property.availableFrom }}</span>
            </div>
          </div>
          <div
            v-if="admin && !enableUpdatedPropertyTile"
            class="font-size-12px mt-10px property_admin"
          >
            <strong>{{ adminFirstName }}</strong> -
            <a
              class="font-weight-bold"
              :href="property.adminPropertyEdit"
              rel="noopener noreferrer"
              target="_blank"
              title="Edit property"
              >edit this property</a
            >
            or
            <a
              class="font-weight-bold"
              :href="property.adminPropertyEdit + '#images'"
              rel="noopener noreferrer"
              target="_blank"
              title="Edit property images"
              >its images</a
            >
            or
            <a
              class="font-weight-bold"
              :href="property.adminLandlordEdit"
              rel="noopener noreferrer"
              target="_blank"
              title="Edit letting agent"
              >edit {{ property.landlord.company }}</a
            >
            or
            <a
              class="font-weight-bold"
              :href="
                property.routeIndex +
                '?letting-agent=' +
                property.landlord.obfuscatedId
              "
              rel="noopener noreferrer"
              target="_blank"
              title="View letting agent properties"
              >view all {{ property.landlord.company }} properties</a
            >?
          </div>
        </div>

        <div
          v-if="showHousemateVoteActions && !useFullWidthHousemateVoteButtons"
          class="tw-mb-[8px] tw-mt-[16px] tw-flex tw-items-center tw-gap-[8px]"
        >
          <button
            type="button"
            class="tw-flex tw-h-[36px] tw-items-center tw-gap-[6px] tw-rounded-[999px] tw-border tw-px-[10px] tw-text-[13px] tw-font-semibold disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
            :class="
              currentGroupVote === 'yes'
                ? 'tw-border-[#497D00] tw-bg-[#F0FDF4] tw-text-[#497D00]'
                : 'tw-border-[#D1D5DB] tw-bg-white tw-text-[#3B4143]'
            "
            :disabled="housemateVotingLocked"
            :aria-pressed="currentGroupVote === 'yes'"
            @click.stop.prevent="submitHousemateVote('yes')"
          >
            <ThumbsUp
              :stroke-color="currentGroupVote === 'yes' ? '#497D00' : '#6B7280'"
            />
            <span>{{ Number(property.groupVoteYesCount ?? 0) }}</span>
          </button>

          <button
            type="button"
            class="tw-flex tw-h-[36px] tw-items-center tw-gap-[6px] tw-rounded-[999px] tw-border tw-px-[10px] tw-text-[13px] tw-font-semibold disabled:tw-cursor-not-allowed disabled:tw-opacity-60"
            :class="
              currentGroupVote === 'no'
                ? 'tw-border-[#E7000B] tw-bg-[#FEF2F2] tw-text-[#E7000B]'
                : 'tw-border-[#D1D5DB] tw-bg-white tw-text-[#3B4143]'
            "
            :disabled="housemateVotingLocked"
            :aria-pressed="currentGroupVote === 'no'"
            @click.stop.prevent="submitHousemateVote('no')"
          >
            <ThumbsDown
              :stroke-color="currentGroupVote === 'no' ? '#E7000B' : '#6B7280'"
            />
            <span>{{ Number(property.groupVoteNoCount ?? 0) }}</span>
          </button>
        </div>

        <div
          v-if="useFullWidthHousemateVoteButtons"
          class="tw-mb-[8px] tw-mt-[16px]"
          @click.stop.prevent
        >
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-[12px]">
            <div class="tw-relative tw-flex-1">
              <Tooltip
                :id="`tooltip-up-${property.id}`"
                :show-tool-tip="
                  targetTooltip === property.id &&
                  targetToolTipContext === 'upVote'
                "
                :can-close-tool-tip="false"
              >
                <template #body> Enquiry already sent </template>
              </Tooltip>

              <button
                type="button"
                class="tw-font-inter tw-flex tw-h-[40px] tw-w-full tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-full tw-border-2 tw-px-[16px] tw-text-[16px] tw-font-medium disabled:tw-cursor-not-allowed disabled:tw-opacity-100 md:tw-px-[11px] md:tw-text-[14px]"
                :class="[
                  housemateUpvoteButtonClasses,
                  !housemateVotingLocked
                    ? 'focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2'
                    : '',
                ]"
                :disabled="housemateVotingLocked"
                :aria-pressed="housemateVoteDirection === 'up'"
                :aria-label="
                  showHousemateVoteActions
                    ? 'Thumbs up'
                    : 'Thumbs up (coming soon)'
                "
                @click.stop.prevent="submitHousemateVote('yes')"
                @mouseenter.stop.prevent="
                  setTargetToolTip(housemateVotingLocked, property, 'upVote')
                "
                @mouseleave.stop.prevent="resetTargetTooltip"
                @focus="
                  setTargetToolTip(housemateVotingLocked, property, 'upVote')
                "
                @blur="resetTargetTooltip"
              >
                <ThumbsUp :stroke-color="housemateUpvoteIconColor" :size="22" />
                <span>{{ housemateUpvoteCount }}</span>
              </button>
            </div>
            <div class="tw-relative tw-flex-1">
              <Tooltip
                :id="`tooltip-down-${property.id}`"
                :show-tool-tip="
                  targetTooltip === property.id &&
                  targetToolTipContext === 'downVote'
                "
                :can-close-tool-tip="false"
              >
                <template #body> Enquiry already sent </template>
              </Tooltip>
              <button
                type="button"
                class="tw-font-inter tw-flex tw-h-[40px] tw-w-full tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-rounded-full tw-border-2 tw-px-[16px] tw-text-[16px] tw-font-medium disabled:tw-cursor-not-allowed disabled:tw-opacity-100 md:tw-px-[11px] md:tw-text-[14px]"
                :class="[
                  housemateDownvoteButtonClasses,
                  !housemateVotingLocked
                    ? 'focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2'
                    : '',
                ]"
                :disabled="housemateVotingLocked"
                :aria-pressed="housemateVoteDirection === 'down'"
                :aria-label="
                  showHousemateVoteActions
                    ? 'Thumbs down'
                    : 'Thumbs down (coming soon)'
                "
                @click.stop.prevent="submitHousemateVote('no')"
                @mouseenter.stop.prevent="
                  setTargetToolTip(housemateVotingLocked, property, 'downVote')
                "
                @mouseleave.stop.prevent="resetTargetTooltip"
                @focus="
                  setTargetToolTip(housemateVotingLocked, property, 'downVote')
                "
                @blur="resetTargetTooltip"
              >
                <ThumbsDown
                  :stroke-color="housemateDownvoteIconColor"
                  :size="22"
                />
                <span>{{ housemateDownvoteCount }}</span>
              </button>
            </div>
          </div>
        </div>

        <div class="px-25px">
          <div
            v-if="shortlistNudgeEnabled && [3, 5].includes(iteration)"
            class="cursor-default position-relative w-100 wow fadeInUp"
            :class="[3].includes(iteration) ? 'd-md-none' : 'd-none d-md-block'"
            data-label="nudge"
          >
            <div
              class="p-20px position-absolute shadow-glow text-white z-i-3 -tw-right-[23px] -tw-top-[153px] tw-w-[250px] tw-rounded-[16px] tw-bg-[#002A51]"
            >
              <span>
                <p
                  class="mb-12px tw-text-center tw-text-[14px] tw-leading-[22px]"
                >
                  Add your favourite properties to your shortlist
                </p>
              </span>
              <!-- prevent only: the delegated hide-nudge handler needs the click to keep bubbling -->
              <div
                data-tile-click-ignore
                class="cursor-pointer px-0 tw-ease tw-w-[214px] tw-rounded-full tw-border tw-border-[#5f7a91] tw-bg-[#1a3f62] tw-px-[20px] tw-py-[10px] tw-text-center tw-text-[16px] tw-font-semibold tw-leading-[32px] tw-text-white tw-transition-all tw-duration-300 hover:tw-bg-[#225483] hover:tw-text-white focus:tw-bg-[#225483]"
                data-action="hide-nudge"
                @click.prevent
              >
                OK
              </div>
            </div>
            <div
              class="h-40px position-absolute shadow-glow w-40px -tw-right-[20px] -tw-top-[146px] -tw-rotate-[27deg] tw--skew-y-[36deg] tw-bg-[#002A51]"
            ></div>
          </div>
        </div>
      </div>
    </a>

    <div
      v-if="admin && enableUpdatedPropertyTile"
      class="updated-property-tile-admin-links tw-px-[16px] tw-pb-[16px]"
    >
      <div class="font-size-12px property_admin">
        <strong>{{ adminFirstName }}</strong> -
        <a
          class="font-weight-bold"
          :href="property.adminPropertyEdit"
          rel="noopener noreferrer"
          target="_blank"
          title="Edit property"
          >edit this property</a
        >
        or
        <a
          class="font-weight-bold"
          :href="property.adminPropertyEdit + '#images'"
          rel="noopener noreferrer"
          target="_blank"
          title="Edit property images"
          >its images</a
        >
        or
        <a
          class="font-weight-bold"
          :href="property.adminLandlordEdit"
          rel="noopener noreferrer"
          target="_blank"
          title="Edit letting agent"
          >edit {{ property.landlord.company }}</a
        >
        or
        <a
          class="font-weight-bold"
          :href="
            property.routeIndex +
            '?letting-agent=' +
            property.landlord.obfuscatedId
          "
          rel="noopener noreferrer"
          target="_blank"
          title="View letting agent properties"
          >view all {{ property.landlord.company }} properties</a
        >?
      </div>
    </div>

    <div v-if="!hideButtons" class="d-none d-lg-flex property_actions">
      <a
        v-if="property.bookable"
        href="javascript:void(0)"
        class="property_action_shortlist tw-rounded-bl-[18px]"
        :data-add-shortlist="property.id"
      >
        <i class="far fa-heart"></i>
      </a>
      <a :href="property.path" class="tw-rounded-br-[18px]">
        <i class="far fa-home fa-unihome"></i> View Home
      </a>
    </div>

    <SaveToShortlistModal
      v-if="enableHousemateGroups && showHousemateGroupTab && isLoggedInStudent"
      :open="showSaveToShortlistModal"
      :property-id="property.id"
      :is-logged-in-student="isLoggedInStudent"
      @close="showSaveToShortlistModal = false"
      @saved="handleSaveDestination"
    />
  </div>
</template>
<script>
import { ADVERT_TYPE_BTR, ADVERT_TYPE_SPARE_ROOM } from '@js/constants';
import {
  availabilityLabelFor,
  hasLivingContext,
  occupancyLabelFor,
} from '@components/Property/livingContext.ts';
import Swiper, { Pagination } from 'swiper';
import { usePropertiesStore } from '@js/stores/properties';
import dayjs from '@dayjs';
import Loading from './Loading';
import ListingIncentive2024 from './Property/ListingIncentive2024';
import PropertyTypePill from './Property/PropertyTypePill.vue';
import PropertyTileChip from './Property/PropertyTileChip.vue';
import Bathtub from '@components/Property/SVG/Bathtub.vue';
import Calendar from '@components/Property/SVG/Calendar.vue';
import HeartOutline from '@components/Property/SVG/HeartOutline.vue';
import SealCheck from '@components/Property/SVG/SealCheck.vue';
import Trash from '@components/Student/SVG/Trash.vue';
import ThumbsUp from '@components/Student/SVG/ThumbsUp.vue';
import ThumbsDown from '@components/Student/SVG/ThumbsDown.vue';
import { observeShortlistAttribute } from '@components/Student/helpers/shortlistObserver';
import { useStudentStore } from '@js/stores/student/student';
import { useFeedbackBar } from '@js/composables/useFeedbackBar';
import SaveToShortlistModal from '@components/Student/Modal/SaveToShortlistModal.vue';
import {
  showShortlistAddedNotification,
  showShortlistRemovedNotification,
  syncShortlistHeaderCount,
} from '@components/Property/shortlistNotification';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/lazy';
import Tooltip from '@components/Student/Tooltip/Tooltip.vue';
import BedRoom from '@components/Property/SVG/BedRoom.vue';
import CaretCircle from '@components/Property/SVG/CaretCircle.vue';
import Occupied from '@components/Property/SVG/Occupied.vue';

const createGuestStudentStore = () => ({
  housemateGroupShortlistedByPropertyId: {},
  isPersonallyShortlisted: () => false,
  async ensureHousemateGroupsShortlistContextLoaded() {},
  async toggleHousemateGroupsShortlist() {},
});

export default {
  name: 'PropertyListing',
  components: {
    Tooltip,
    Loading,
    ListingIncentive2024,
    PropertyTypePill,
    PropertyTileChip,
    CaretCircle,
    Bathtub,
    Calendar,
    HeartOutline,
    SealCheck,
    Trash,
    SaveToShortlistModal,
    ThumbsUp,
    ThumbsDown,
    BedRoom,
    Occupied,
  },
  inject: {
    shortlistNotificationsEnabled: {
      default: false,
    },
    bookingCompletePage: {
      default: false,
    },
  },
  props: {
    abbreviate: {
      default: true,
      type: Boolean,
    },
    admin: {
      default: false,
      type: Boolean,
    },
    mapIsOpen: {
      default: false,
      type: Boolean,
    },
    isLoggedInStudent: {
      default: false,
      type: Boolean,
    },
    adminFirstName: {
      default: null,
      type: String,
    },
    bottomOfThePage: {
      default: window.innerHeight,
      type: Number,
    },
    classList: {
      default: 'h-100 m-0',
      type: String,
    },
    currentScroll: {
      default: 0,
      type: Number,
    },
    hideButtons: {
      default: true,
      type: Boolean,
    },
    imgClasses: {
      default: 'max-w-100',
      type: String,
    },
    iteration: {
      default: 0,
      type: Number,
    },
    listing: {
      default: 'listing',
      type: String,
    },
    paginate: {
      default: 18,
      type: Number,
    },
    property: {
      default: function () {
        return {};
      },
      required: true,
      type: Object,
    },
    reloading: {
      default: false,
      type: Boolean,
    },
    screenKey: {
      default: null,
      type: String,
    },
    shortlistNudgeEnabled: {
      default: false,
      type: Boolean,
    },
    streamlined: {
      default: false,
      type: Boolean,
    },
    swiperClasses: {
      default: null,
      type: String,
    },
    windowHeight: {
      default: window.innerHeight,
      type: Number,
    },
    isShortlistView: {
      default: false,
      type: Boolean,
    },
    shortlistReadOnly: {
      default: false,
      type: Boolean,
    },
    shortlistActive: {
      default: false,
      type: Boolean,
    },
    enableShortlistInSearch: {
      default: false,
      type: Boolean,
    },
    enableHousemateGroups: {
      default: null,
      type: Boolean,
    },
    enableUpdatedPropertyTile: {
      default: false,
      type: Boolean,
    },
    /**
     * Softer, tighter shadow for dense layouts (e.g. similar-properties carousel)
     * where the default 20px blur is clipped by overflow or peeks neighbouring cards.
     */
    reducedShadow: {
      default: false,
      type: Boolean,
    },
    showHousemateGroupTab: {
      default: true,
      type: Boolean,
    },
    housemateGroupActive: {
      default: false,
      type: Boolean,
    },
    housemateGroupId: {
      default: null,
      type: [Number, String],
    },
    showHousemateVotePlaceholders: {
      default: false,
      type: Boolean,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    shortlistSelectionMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      studentStore: this.isLoggedInStudent
        ? useStudentStore()
        : createGuestStudentStore(),
      shortlistStateStore: useStudentStore(),
      feedbackBar: useFeedbackBar(),
      mountDone: false,
      swiper: null,
      swiperId: null,
      swiperSlides: this.property.images,
      shortlistedLocal: this.shortlistActive || this.property.shortlisted,
      shortlistedHousemateGroupId: null,
      ADVERT_TYPE_BTR,
      ADVERT_TYPE_SPARE_ROOM,
      windowWidth: window.innerWidth,
      localIsSelected: this.isSelected,
      showSaveToShortlistModal: false,
      targetTooltip: false,
      targetToolTipContext: null,
      shareStatus: '',
    };
  },
  computed: {
    eagerImageCount() {
      return this.enableUpdatedPropertyTile ? 4 : 3;
    },
    showIncentiveBadge() {
      return (
        !this.lastEnquiredAtRelative &&
        this.showIncentives &&
        !!this.property.incentive
      );
    },
    /**
     * The shortlist tab puts a 56px selection checkbox in the image's top-left
     * corner, which the pill sits under, so the pill stands down there. The
     * search page keeps it - gating on the housemate groups flag alone would
     * drop it from every tile and leave the Blade still-copy painting pills the
     * mounted tile removes.
     */
    showPropertyTypePill() {
      return (
        this.enableUpdatedPropertyTile &&
        !this.lastEnquiredAtRelative &&
        !this.showIncentiveBadge &&
        !this.property.isFeatured &&
        !(this.enableHousemateGroups && this.isShortlistView) &&
        !this.isFullyOccupiedSpareRoom
      );
    },
    isFullyOccupiedSpareRoom() {
      return (
        this.isSpareRoomProperty && !this.property.spareRoomsAvailableCount
      );
    },
    imageFrameClass() {
      return this.enableUpdatedPropertyTile
        ? 'tw-h-[180px]'
        : 'aspect-ratio-airbnb';
    },
    groupLastEnquiredAt() {
      return (
        this.property?.housemateGroupLastEnquiredAt ??
        this.property?.housemate_group_last_enquired_at ??
        null
      );
    },
    displayLastEnquiredAt() {
      return this.property?.lastEnquiredAt ?? this.groupLastEnquiredAt ?? null;
    },
    lastEnquiredAtRelative() {
      const enquiredAt = this.displayLastEnquiredAt;

      if (!enquiredAt) {
        return;
      }

      const now = dayjs();
      const isToday = dayjs(enquiredAt).isToday();
      const hourDiff = now.diff(enquiredAt, 'hour');
      const weekDiff = now.diff(enquiredAt, 'week');
      const yesterdayStart = dayjs().subtract(1, 'day').startOf('day');
      const isYesterday =
        dayjs(enquiredAt).isAfter(yesterdayStart) &&
        dayjs(enquiredAt).isBefore(dayjs().startOf('day'));

      if (hourDiff > 11 && isToday) {
        return 'Today';
      }

      if (isYesterday && !isToday) {
        return 'Yesterday';
      }

      if (weekDiff > 3) {
        return dayjs(enquiredAt).format('DD/MM/YYYY');
      }

      return dayjs(enquiredAt).fromNow();
    },
    isLastEnquiredOlderThanThreeWeeks() {
      const enquiredAt = this.displayLastEnquiredAt;

      if (!enquiredAt) {
        return false;
      }

      return dayjs().diff(enquiredAt, 'week') > 3;
    },
    availableFromLowercase() {
      const str = this.property.availableFrom;
      if (!str) return str; // Check for empty string or null
      return str.charAt(0).toLowerCase() + str.slice(1);
    },

    housemateVoteDirection() {
      if (this.showHousemateVoteActions) {
        if (this.currentGroupVote === 'yes') {
          return 'up';
        }

        if (this.currentGroupVote === 'no') {
          return 'down';
        }

        return null;
      }

      const candidate =
        this.property?.housemateVoteDirection ??
        this.property?.housemate_vote_direction ??
        this.property?.housemateVote ??
        this.property?.housemate_vote ??
        this.property?.voteDirection ??
        this.property?.vote_direction ??
        null;

      if (candidate === null || candidate === undefined) {
        return null;
      }

      const normalized = String(candidate).toLowerCase();
      if (['up', 'upvote', 'thumbsup', 'like', '1'].includes(normalized)) {
        return 'up';
      }
      if (
        ['down', 'downvote', 'thumbsdown', 'dislike', '-1'].includes(normalized)
      ) {
        return 'down';
      }

      return null;
    },

    housemateUpvoteCount() {
      const candidates = [
        this.property?.groupVoteYesCount,
        this.property?.group_vote_yes_count,
        this.property?.housemateUpvoteCount,
        this.property?.housemate_upvote_count,
        this.property?.housemateUpvotes,
        this.property?.housemate_upvotes,
        this.property?.upvoteCount,
        this.property?.upvote_count,
        this.property?.upvotes,
      ];

      for (const value of candidates) {
        const num = Number(value);
        if (Number.isFinite(num)) return num;
      }

      return 0;
    },

    housemateDownvoteCount() {
      const candidates = [
        this.property?.groupVoteNoCount,
        this.property?.group_vote_no_count,
        this.property?.housemateDownvoteCount,
        this.property?.housemate_downvote_count,
        this.property?.housemateDownvotes,
        this.property?.housemate_downvotes,
        this.property?.downvoteCount,
        this.property?.downvote_count,
        this.property?.downvotes,
      ];

      for (const value of candidates) {
        const num = Number(value);
        if (Number.isFinite(num)) return num;
      }

      return 0;
    },

    housemateUpvoteIconColor() {
      return this.housemateVoteDirection === 'up' ? '#497D00' : '#3B4143';
    },

    housemateDownvoteIconColor() {
      return this.housemateVoteDirection === 'down' ? '#DC2626' : '#3B4143';
    },

    housemateUpvoteButtonClasses() {
      if (this.housemateVoteDirection === 'up') {
        return 'tw-border-[#497D00] tw-bg-[#F3F8E8] tw-text-[#497D00]';
      }

      return 'tw-border-[#D1D5DB] tw-bg-white tw-text-[#6B7280]';
    },

    housemateDownvoteButtonClasses() {
      if (this.housemateVoteDirection === 'down') {
        return 'tw-border-[#DC2626] tw-bg-[#FEF2F2] tw-text-[#DC2626]';
      }

      return 'tw-border-[#D1D5DB] tw-bg-white tw-text-[#6B7280]';
    },
    // Generate responsive image URLs using Cloudflare CDN width parameters
    getResponsiveImageUrls() {
      return (image) => {
        const baseUrl = image?.fileURLTablet ?? null;
        if (!baseUrl) return null;

        // Replace width parameter in Cloudflare CDN URL
        const mobileUrl = baseUrl
          .replace(/width=\d+/, 'width=390')
          .replace(/quality=75/, 'quality=90');
        const smallUrl = baseUrl
          .replace(/width=\d+/, 'width=535')
          .replace(/quality=75/, 'quality=90');
        const tabletUrl = baseUrl
          .replace(/width=\d+/, 'width=468')
          .replace(/quality=75/, 'quality=90');
        const desktopUrl = baseUrl
          .replace(/width=\d+/, 'width=400')
          .replace(/quality=75/, 'quality=90');
        const twoColUrl = baseUrl
          .replace(/width=\d+/, 'width=548')
          .replace(/quality=75/, 'quality=90');

        return {
          mobile: mobileUrl,
          small: smallUrl,
          tablet: tabletUrl,
          desktop: desktopUrl,
          twoCol: twoColUrl,
          fallback: this.propertyMainImage?.fileURLTablet ?? null,
        };
      };
    },
    isShortlisted() {
      return this.shortlistedLocal;
    },
    liveAt() {
      const liveAtDate = dayjs(this.property.liveAt);

      if (!liveAtDate || !liveAtDate.isValid()) {
        return null;
      }

      const now = dayjs();

      const daysDiff = now.diff(liveAtDate, 'day');
      const weeksDiff = now.diff(liveAtDate, 'week');
      const monthsDiff = now.diff(liveAtDate, 'month');
      const yearsDiff = now.diff(liveAtDate, 'year');

      // Hide "Added X ago" if older than 3 weeks (21 days)
      if (daysDiff > 21) {
        return null;
      }

      // Handle the "today" case properly
      if (daysDiff < 1) {
        return 'Added today';
      } else if (daysDiff < 2) {
        return 'Added yesterday';
      } else if (daysDiff < 7) {
        return `Added ${daysDiff} days ago`;
      } else if (weeksDiff === 1) {
        return 'Added 1 week ago';
      } else if (weeksDiff < 5) {
        return `Added ${weeksDiff} weeks ago`;
      } else if (monthsDiff === 1) {
        return 'Added 1 month ago';
      } else if (monthsDiff < 12) {
        return `Added ${monthsDiff} months ago`;
      } else {
        // This shouldn't happen since we filter out years above, but just in case
        return yearsDiff === 1
          ? 'Added 1 year ago'
          : `Added ${yearsDiff} years ago`;
      }
    },
    bottom() {
      return this.mountDone && this.$refs.propertyListing
        ? this.$refs.propertyListing.getBoundingClientRect().bottom +
            this.browserTop
        : false;
    },
    browserTop() {
      return window.scrollY;
    },
    showSkeleton() {
      return false;
    },
    showLoader() {
      return this.reloading;
    },
    isBTRProperty() {
      return this.property.advertType === ADVERT_TYPE_BTR;
    },
    isSpareRoomProperty() {
      return this.property.advertType === ADVERT_TYPE_SPARE_ROOM;
    },
    hasPriceRange() {
      return (
        this.property.cheapestRoomPrice !== this.property.mostExpensiveRoomPrice
      );
    },
    bathroomLabel() {
      return Number(this.property.bathroomCount) === 1
        ? 'bathroom'
        : 'bathrooms';
    },
    btrRoomOptionsLabel() {
      if (!this.isBTRProperty || !this.property.btrRoomsCount) {
        return null;
      }

      const count = this.property.btrRoomsCount;

      return `${count} room ${count > 1 ? 'options' : 'option'}`;
    },
    isBlendedListing() {
      return hasLivingContext(this.property);
    },
    spareRoomsAvailableLabel() {
      // Blended results count the rooms of any partially occupied home, not just spare room adverts
      if (this.isBlendedListing) {
        return availabilityLabelFor(this.property);
      }

      if (
        !this.isSpareRoomProperty ||
        !this.property.spareRoomsAvailableCount
      ) {
        return null;
      }

      const count = this.property.spareRoomsAvailableCount;

      return `${count} ${count > 1 ? 'rooms' : 'room'} available`;
    },
    occupiedRoomsLabel() {
      // A blended spare room advert reports its live rooms in roomsAvailableCount, so the
      // occupied rooms are what is left of the house rather than a difference of two counts
      if (this.isBlendedListing) {
        return occupancyLabelFor(this.property);
      }

      if (!this.isSpareRoomProperty) {
        return null;
      }

      const occupied =
        (this.property.roomsAvailableCount ?? 0) -
        (this.property.spareRoomsAvailableCount ?? 0);

      return occupied > 0 ? `${occupied} occupied` : null;
    },
    showPriceFromPrefix() {
      return (
        this.property.showFrom &&
        !this.isBTRProperty &&
        !this.isSpareRoomProperty
      );
    },
    displayPrice() {
      return this.isBTRProperty || this.isSpareRoomProperty
        ? `£${this.property.cheapestRoomPrice}`
        : this.price;
    },
    compactDisplayPrice() {
      return this.displayPrice.replace(/\.\d+/, '');
    },
    compactAvailableFrom() {
      return this.property.availableFromShort
        .replace('Available from ', 'Available ')
        .replace(/\b\d{2}(\d{2})$/, "'$1");
    },
    pricePeriodLabel() {
      return this.isBTRProperty || this.isSpareRoomProperty ? 'pw' : 'pppw';
    },
    price() {
      const { price, cheapestRoomPrice, mostExpensiveRoomPrice } =
        this.property;

      if (this.isBTRProperty && this.hasPriceRange) {
        return `£${cheapestRoomPrice} - £${mostExpensiveRoomPrice}`;
      }

      return `£${price}`;
    },
    top() {
      return this.mountDone && this.$refs.propertyListing
        ? this.$refs.propertyListing.getBoundingClientRect().top +
            this.browserTop
        : false;
    },
    showIncentives() {
      return usePropertiesStore().showIncentives;
    },
    propertyMainImage() {
      return this.property?.mainImage
        ? {
            fileURLTablet: this.property.mainImage,
          }
        : null;
    },
    showHousemateVoteActions() {
      return Boolean(
        this.housemateGroupActive &&
          this.housemateGroupId &&
          !this.isShortlistView
      );
    },
    housemateVotingLocked() {
      return (
        !this.showHousemateVoteActions || Boolean(this.groupLastEnquiredAt)
      );
    },
    currentGroupVote() {
      return typeof this.property?.groupVote === 'string'
        ? this.property.groupVote.toLowerCase()
        : null;
    },
    useFullWidthHousemateVoteButtons() {
      return Boolean(
        this.showHousemateVotePlaceholders || this.housemateGroupActive
      );
    },
  },
  watch: {
    property: {
      handler(newVal) {
        if (
          this.enableHousemateGroups &&
          this.showHousemateGroupTab &&
          this.isLoggedInStudent
        ) {
          const propertyId = newVal?.id;
          const groupId = propertyId
            ? this.studentStore.housemateGroupShortlistedByPropertyId?.[
                String(propertyId)
              ]
            : null;

          if (groupId) {
            this.shortlistedLocal = true;
            this.shortlistedHousemateGroupId = Number(groupId);
          } else if (propertyId) {
            this.shortlistedHousemateGroupId = null;
            this.shortlistedLocal =
              this.studentStore.isPersonallyShortlisted?.(propertyId);
          } else {
            this.shortlistedLocal = Boolean(newVal.shortlisted);
          }
        } else {
          this.shortlistedLocal =
            this.shortlistActive || Boolean(newVal.shortlisted);
        }
        this.swiperSlides = newVal.images;
      },
      deep: true,
    },
    reloading: function (boolean) {
      if (boolean) {
        // Pop off all the current slides
        if (!this.isShortlistView) {
          this.swiperSlides = [];
        }

        this.mountDone = false;
      } else {
        // Put the new images into the slider
        this.swiperSlides = this.property.images;
        this.swiperReload();
        this.mountDone = true;
      }
    },
    screenKey: function () {
      // Map opening and closing, screen being moved etc
    },
    isSelected(newVal) {
      this.localIsSelected = newVal;
    },
  },

  mounted() {
    this.mountDone = true;
    this.swiperId = this.makeId(10);
    this.setupSwiper();

    if (
      this.enableHousemateGroups &&
      this.showHousemateGroupTab &&
      this.isLoggedInStudent
    ) {
      const heartEl = this.$el.querySelector('.heart_new');
      this.shortlistObserver = observeShortlistAttribute(heartEl);

      // Preload settings + personal shortlist ids so click handling can be deterministic.
      (async () => {
        await this.studentStore
          .ensureHousemateGroupsShortlistContextLoaded?.()
          .catch(() => null);

        const propertyId = this.property?.id;
        if (!propertyId) {
          return;
        }

        const groupId =
          this.studentStore.housemateGroupShortlistedByPropertyId?.[
            String(propertyId)
          ];

        if (groupId) {
          this.shortlistedLocal = true;
          this.shortlistedHousemateGroupId = Number(groupId);
          return;
        }

        this.shortlistedHousemateGroupId = null;
        this.shortlistedLocal =
          this.studentStore.isPersonallyShortlisted?.(propertyId) ||
          Boolean(this.property?.shortlisted);
      })();
    }
  },
  updated() {
    const swiperElement = this.$refs.swiper;

    if (this.swiper?.el === swiperElement) {
      return;
    }

    const activeIndex = this.swiper?.realIndex || 0;
    this.swiper?.destroy();
    this.swiper = null;

    if (!swiperElement) {
      return;
    }

    this.setupSwiper();

    if (activeIndex > 0) {
      this.swiper?.slideTo(activeIndex, 0, false);
    }
  },
  beforeDestroy() {
    if (this.shortlistObserver) {
      this.shortlistObserver.disconnect();
    }
  },

  methods: {
    async shareProperty() {
      const shareData = {
        title: this.property.title || 'Check out this property',
        text: 'Found this property you might like:',
        url: new URL(this.property.path, window.location.origin).href,
      };

      if (navigator.share) {
        try {
          await navigator.share(shareData);
          return;
        } catch (error) {
          if (error.name === 'AbortError') return;
        }
      }

      let copied = false;

      try {
        await navigator.clipboard.writeText(shareData.url);
        copied = true;
      } catch (error) {
        const input = document.createElement('textarea');
        input.value = shareData.url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        input.select();
        copied = document.execCommand('copy');
        input.remove();
      }

      this.shareStatus = copied ? 'Link copied' : 'Unable to copy link';
      window.setTimeout(() => {
        this.shareStatus = '';
      }, 2000);
    },
    resetTargetTooltip() {
      this.targetTooltip = null;
    },
    setTargetToolTip(isDisabled, property, context) {
      if (!isDisabled) return;

      if (property.id !== this.property.id) return;

      this.targetToolTipContext = context;
      this.targetTooltip = property.id;
    },
    async toggleShortlist(event) {
      const propertyId = this.property?.id;
      if (!propertyId) {
        return;
      }

      if (this.enableShortlistInSearch || this.bookingCompletePage) {
        event?.stopPropagation?.();
        event?.stopImmediatePropagation?.();
      }

      if (
        this.enableShortlistInSearch &&
        this.shortlistActive &&
        !this.shortlistReadOnly &&
        this.shortlistedLocal
      ) {
        this.$emit('remove-from-shortlist', propertyId);
        return;
      }

      if (
        !this.enableHousemateGroups ||
        !this.showHousemateGroupTab ||
        !this.isLoggedInStudent
      ) {
        const currentlyShortlisted = this.shortlistedLocal;

        if (this.enableShortlistInSearch) {
          this.shortlistedLocal = !currentlyShortlisted;
        }

        try {
          if (currentlyShortlisted) {
            await this.shortlistStateStore.removeFromShortlist(propertyId);
            this.shortlistedLocal = false;
            syncShortlistHeaderCount(this.shortlistStateStore.shortlistCount);
            if (this.shortlistNotificationsEnabled) {
              this.showPersonalShortlistRemovedFeedback();
            } else if (this.bookingCompletePage) {
              this.feedbackBar.show(
                'Removed from your shortlist',
                'tw-bg-primary-grey'
              );
            }
            return;
          }

          const response = await this.shortlistStateStore.postAddToShortlist(
            propertyId,
            this.property
          );

          if (!response?.data?.success) {
            this.shortlistedLocal = currentlyShortlisted;
            return;
          }

          this.shortlistedLocal = true;
          syncShortlistHeaderCount(
            response.data.count ?? this.shortlistStateStore.shortlistCount
          );
          if (this.shortlistNotificationsEnabled) {
            showShortlistAddedNotification(this.property);
          } else if (this.bookingCompletePage) {
            this.feedbackBar.show('Added to your shortlist');
          }
        } catch {
          this.shortlistedLocal = currentlyShortlisted;
        }

        return;
      }

      event?.stopPropagation?.();
      event?.stopImmediatePropagation?.();

      const result = await this.studentStore.toggleHousemateGroupsShortlist?.({
        propertyId,
        property: this.property,
        currentHousemateGroupId: this.shortlistedHousemateGroupId,
        isUiShortlisted: this.shortlistedLocal,
      });

      if (result?.action === 'needs-modal') {
        this.showSaveToShortlistModal = true;
        return;
      }

      if (result?.action === 'added-personal') {
        this.shortlistedLocal = true;
        this.shortlistedHousemateGroupId = null;
        syncShortlistHeaderCount(this.shortlistStateStore.shortlistCount);
        if (this.shortlistNotificationsEnabled) {
          showShortlistAddedNotification(this.property);
        }
        return;
      }

      if (result?.action === 'added-group') {
        this.shortlistedLocal = true;
        this.shortlistedHousemateGroupId = result?.groupId ?? null;
        return;
      }

      if (
        result?.action === 'removed-personal' ||
        result?.action === 'removed-group'
      ) {
        this.shortlistedLocal = false;
        this.shortlistedHousemateGroupId = null;
        if (result?.action === 'removed-personal') {
          syncShortlistHeaderCount(this.shortlistStateStore.shortlistCount);
          this.showPersonalShortlistRemovedFeedback();
        }
      }
    },
    showPersonalShortlistRemovedFeedback() {
      if (!this.shortlistNotificationsEnabled) return;

      showShortlistRemovedNotification(this.property, async () => {
        if (this.shortlistedLocal) return true;

        const propertyId = String(this.property?.id || '').trim();
        if (!propertyId) return false;

        const response = await this.shortlistStateStore.postAddToShortlist(
          propertyId,
          this.property
        );
        if (!response?.data?.success) return false;

        this.shortlistedLocal = true;
        this.shortlistedHousemateGroupId = null;
        syncShortlistHeaderCount(
          response.data.count ?? this.shortlistStateStore.shortlistCount
        );
        return true;
      });
    },
    handleSaveDestination(payload = {}) {
      this.shortlistedLocal = true;

      if (payload?.destination === 'group') {
        this.shortlistedHousemateGroupId = payload?.groupId ?? null;
      } else {
        this.shortlistedHousemateGroupId = null;
        syncShortlistHeaderCount(this.shortlistStateStore.shortlistCount);
        if (this.shortlistNotificationsEnabled) {
          showShortlistAddedNotification(this.property);
        }
      }
    },
    submitHousemateVote(vote) {
      if (this.housemateVotingLocked) {
        return;
      }

      if (!['yes', 'no'].includes(vote)) {
        return;
      }

      this.$emit('housemate-group-vote', {
        propertyId: this.property.id,
        vote,
      });
    },
    makeId: function (length) {
      let result = '',
        characters =
          'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
        charactersLength = characters.length;
      for (let i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    setupSwiper: function () {
      const swiperElement = this.$refs.swiper;

      if (!swiperElement) {
        return;
      }

      if (this.enableUpdatedPropertyTile) {
        swiperElement.classList.add('pagination-initializing');
      }

      this.swiper = new Swiper(swiperElement, {
        roundLengths: true, // Rounds pixel values to whole numbers
        observer: true, // Detects changes to the swiper or its children
        observeParents: true, // Detects changes to the container (the resize)
        resizeObserver: true,
        centeredSlides: true, // Helps snap the active slide to center pixels
        resistanceRatio: 0, // Prevents "bouncing" which reveals edges

        // Force recalculation on resize
        updateOnWindowResize: true,
        // Optional parameters
        loop: this.loop,
        // Disable preloading of all images
        preloadImages: false,

        // configure Swiper to use modules
        modules: [Pagination],

        // If we need pagination
        pagination: {
          clickable: true,
          el: '.swiper-pagination',
          dynamicBullets: true,
          /* the updated tile caps its strip at seven bullets, the legacy tile at eight */
          dynamicMainBullets: this.enableUpdatedPropertyTile ? 3 : 4,
          type: 'bullets',
        },
      });

      this.swiper.on('slideChange', () => {
        this.swiper.update();
      });

      if (this.enableUpdatedPropertyTile) {
        this.swiper.on('paginationUpdate', () => this.alignPaginationWindow());
        this.alignPaginationWindow();

        requestAnimationFrame(() => {
          swiperElement.classList.remove('pagination-initializing');
        });
      }
    },
    /*
    The strip opens on five bullets and gains one with every slide until it
    reaches seven, from where it slides along - the legacy tile's behaviour.
    Swiper marks the bullets it means to show but then offsets them as though
    each were the width of the first, so the wider active pill pushes every
    bullet after it out of the window and the strip clips at one end. Its
    choice of bullets is kept; only the geometry is measured again.
     */
    alignPaginationWindow: function () {
      const pagination = this.swiper && this.swiper.pagination;

      if (!pagination || !pagination.$el || !pagination.bullets.length) {
        return;
      }

      const bullets = pagination.bullets;
      const activeClass = this.swiper.params.pagination.bulletActiveClass;
      const windowClasses = [
        `${activeClass}-main`,
        `${activeClass}-prev`,
        `${activeClass}-prev-prev`,
        `${activeClass}-next`,
        `${activeClass}-next-next`,
      ];

      let first = -1;
      let last = -1;
      let activeIndex = -1;

      for (let index = 0; index < bullets.length; index += 1) {
        const classList = bullets[index].classList;

        if (classList.contains(activeClass)) {
          activeIndex = index;
        }

        if (windowClasses.some((name) => classList.contains(name))) {
          first = first < 0 ? index : first;
          last = index;
        }
      }

      if (first < 0 || activeIndex < 0) {
        return;
      }

      const bulletWidth = bullets
        .eq(activeIndex === 0 ? 1 : 0)
        .outerWidth(true);
      const pillWidth = bullets.eq(activeIndex).outerWidth(true);
      const windowWidth =
        (last - first + 1) * bulletWidth + (pillWidth - bulletWidth);

      pagination.$el.css('width', `${windowWidth}px`);
      bullets.css('left', `${-(first * bulletWidth)}px`);
    },
    swiperReload: function () {
      // Once all the images have been reloaded, reinitialise the swiper
      this.$nextTick(() => {
        this.setupSwiper();
      });
    },
    screenResized: function () {
      // Once all the images have been reloaded, reinitialise the swiper
      this.$nextTick(() => {
        this.setupSwiper();
      });
    },
    UCFirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    redirectToPropertyPage() {
      //I think isn't getting hit as its called in an @click next to a href
      if (typeof ga === 'undefined') {
        window.location = this.property.path;
        return;
      }

      let clickEventData = {
        incentive: false,
      };
      if (this.property.incentive) {
        clickEventData.incentive = {
          type: this.property.incentive.type,
          message: this.property.incentive.message,
          visible: this.showIncentives,
        };
      }

      ga('send', 'property_card_click', 'Properties', 'Card', clickEventData);
      window.location = this.property.path;
    },
    handleSwiperNavClick(direction) {
      event.preventDefault();
      event.stopPropagation();

      if (this.swiper) {
        direction === 'next'
          ? this.swiper.slideNext()
          : this.swiper.slidePrev();
      }
    },
    onSelectChange(event) {
      const checked = event.target.checked;

      this.localIsSelected = checked;

      this.$emit('selection-change', {
        id: this.property.id,
        checked,
      });
    },
  },
};
</script>
<style lang="scss">
.propertyListingSwiper {
  width: calc(100% + 2px) !important;
  left: -1px;
  position: relative;

  .swiper-lazy-preloader {
    border-right-color: #00a2e1 !important;
    border-bottom-color: #00a2e1 !important;
    border-left-color: #00a2e1 !important;
  }

  .swiper-pagination {
    top: auto;
    transform: translate3d(0, 0, 0);

    .swiper-pagination-bullet {
      transform: scale(1);
      border: none;
      background: white;
      height: 6px;
      margin: 0 3px;
      opacity: 0.5 !important;
      transition-property: left;
      width: 6px;

      &.swiper-pagination-bullet-active {
        opacity: 1 !important;
        background: white !important;
        height: 6px !important;
        width: 6px !important;
      }
    }
  }
}

.updated-property-tile {
  .propertyListingSwiper.pagination-initializing
    .swiper-pagination
    .swiper-pagination-bullet {
    transition: none !important;
  }

  .propertyListingSwiper .swiper-pagination {
    left: 50%;
    white-space: nowrap;
    transform: translateX(-50%);
  }

  /* alignPaginationWindow places the strip itself, so it cannot also be centred here */
  .propertyListingSwiper .swiper-pagination-bullets-dynamic {
    text-align: left;
  }

  .propertyListingSwiper .swiper-pagination .swiper-pagination-bullet {
    height: 8px !important;
    width: 8px !important;
    box-shadow: none;
    margin: 0 2px;
    opacity: 0.8 !important;
  }
  .propertyListingSwiper
    .swiper-pagination
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
    border-radius: 4px;
    height: 8px !important;
    width: 18px !important;
  }
}
</style>
